import { ActionTypes } from 'constants/AdminConstants';
import { ModalTypeSchema } from 'stores/ModalStateStore/types';
import { submitScore } from './ServerActionCreators';
import Dispatcher from '../dispatcher/Dispatcher';
var SCORE = ModalTypeSchema.Enum.SCORE;
export var openScoreForm = function () {
    var openModalAction = {
        type: ActionTypes.OPEN_MODAL,
        content: SCORE
    };
    Dispatcher.dispatch(openModalAction);
};
export var closeScoreForm = function () {
    var closeModalAction = {
        type: ActionTypes.CLOSE_MODAL
    };
    Dispatcher.dispatch(closeModalAction);
};
export var submitScoreForm = function (data, formId) {
    submitScore(data, formId);
};
export default {
    openScoreForm: openScoreForm,
    closeScoreForm: closeScoreForm,
    submitScoreForm: submitScoreForm
};
